import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { generatePublishOfferClickAction } from '../../actions/webview';
import {
  selectIsPublishButtonDisabled,
  selectIsPublishButtonPending,
  selectPublicationButtonText,
} from '../../selectors/checkoutInfo';
import { selectIsSubagentMasterAccountMoneyLimitExceeded } from '../../selectors/balance';
import { setPlacingMoneySource } from '../../actions/publishTerms';
import { EMoneySource } from '../../types/reducers/user';
import { loadPublishTerms } from '../../thunks/publishTerms/loadPublishTerms';
import { TDispatch } from '../../../common/types/dispatch';
import { useAppContext } from '../../../AppModulesWrapper';
import { PublishButton } from './components/PublishButton';
import { SelfMoneySourceButton } from './components/SelfMoneySourceButton';
import { usePublishButtonAnalytics } from './hooks';
import { processPublishOfferThunk } from '../../thunks/offer/processPublishOffer';

export const PublishButtonContainer = () => {
  const { webview } = useAppContext();

  const { trackPublishClick } = usePublishButtonAnalytics();

  const isPending = useSelector(selectIsPublishButtonPending);
  const text = useSelector(selectPublicationButtonText);
  const isDisabled = useSelector(selectIsPublishButtonDisabled);
  const isSubagentMasterAccountMoneyLimitExceeded = useSelector(selectIsSubagentMasterAccountMoneyLimitExceeded);

  const dispatch = useDispatch<TDispatch>();

  const handleSelfMoneySourceButtonClick = React.useCallback(() => {
    dispatch(setPlacingMoneySource(EMoneySource.Self));
    dispatch(loadPublishTerms());
  }, [dispatch]);

  const handlePublishButtonClick = React.useCallback(() => {
    webview.sendAction(generatePublishOfferClickAction(isDisabled));

    if (isDisabled) {
      return;
    }

    trackPublishClick();

    dispatch(processPublishOfferThunk());
  }, [webview, isDisabled, trackPublishClick, dispatch]);

  return isSubagentMasterAccountMoneyLimitExceeded ? (
    <SelfMoneySourceButton handleButtonClick={handleSelfMoneySourceButtonClick} isPending={isPending} />
  ) : (
    <PublishButton text={text} handleButtonClick={handlePublishButtonClick} isPending={isPending} />
  );
};
